export const PAGE_SIZE = 20;

export const STATUS_OPTIONS = [
    { value: '', label: 'All statuses' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Sending', label: 'Sending' },
    { value: 'Sent', label: 'Sent' },
    { value: 'Failed', label: 'Failed' },
];

export function getStatusColor(status: string): string {
    switch (status) {
        case 'Sent':
            return 'green';
        case 'Sending':
            return 'blue';
        case 'Failed':
            return 'red';
        default:
            return 'gray';
    }
}

export function trimLeadingZeros(sku: string): string {
    const trimmed = sku.replace(/^0+/, '');
    return trimmed.length > 0 ? trimmed : sku;
}
